import { Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";

export interface TextCustomProps {
  overflowTooltip?: boolean;
  bold400?: boolean;
  bold500?: boolean;
  bold600?: boolean;
  blur?: boolean;
  children: ReactNode;
  mobile?: boolean;
  fullWidth?: boolean;
  inline?: boolean;
  lineSpace?: boolean;
}

export interface TextType {
  type?:
    | "small"
    | "body"
    | "subtitle"
    | "subtitle2"
    | "title"
    | "bigTitle"
    | "superTitle"
    | "button"
    | "buttonLarge";
}
export type CustomTextProps = TextCustomProps & TextType & TypographyProps;

export function CustomText({
  overflowTooltip,
  bold400,
  bold500,
  bold600,
  blur,
  children,
  mobile,
  fullWidth,
  type: textType = "body",
  inline,
  lineSpace,
  ...props
}: CustomTextProps) {
  const fontSizeMap = {
    small: "12px",
    body: "14px",
    subtitle: "16px",
    subtitle2: "18px",
    title: "20px",
    bigTitle: "24px",
    superTitle: "32px",
    button: "16px",
    buttonLarge: "18px",
  };

  const fontWeightMap = {
    small: 400,
    body: 400,
    subtitle: 600,
    subtitle2: 500,
    title: 600,
    bigTitle: 600,
    superTitle: 600,
    button: 500,
    buttonLarge: 600,
  };

  const fontSize = fontSizeMap[textType];
  const baseFontWeight = fontWeightMap[textType];

  return (
    <Typography
      sx={{
        fontSize: fontSize,
        cursor: textType === "body" ? "pointer" : "default",
        fontWeight: baseFontWeight,
        ...(fullWidth
          ? {
              width: "100%",
            }
          : {}),
        ...(overflowTooltip
          ? {
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }
          : {}),
        ...(bold400
          ? {
              fontWeight: 400,
            }
          : {}),
        ...(bold500
          ? {
              fontWeight: 500,
            }
          : {}),
        ...(bold600
          ? {
              fontWeight: 600,
            }
          : {}),
        ...(blur
          ? {
              opacity: 0.5,
            }
          : {}),
        ...(lineSpace ? {} : { whiteSpace: "nowrap" }),
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}
